export const ServiceType = {
  SEIMITSU: 'seimitsu',
  KENSHIN: 'kenshin',
  ALL: 'all',
};
